import * as Yup from 'yup';
import {
  IPricing,
  ITaxesValues,
}               from '@typings/invoiceManagement';

export const defaultPricingSchema: Yup.Schema<IPricing> = Yup.object().shape({
  monthlyFee            : Yup.number().required(),
  personalFee           : Yup.number().required(),
  dealerFee             : Yup.number().required(),
  nadaMonthlyFee        : Yup.number().required(),
  nadaBookOutFee        : Yup.number().required(),
  expressRecoveryFee    : Yup.number().required(),
  deficiencyTrackingFee : Yup.number().required(),
  vrmFee                : Yup.number().required(),
  srsFee                : Yup.number().required(),
  reindeerFee           : Yup.number().required(),
});

export const taxesSchema: Yup.ObjectSchema<ITaxesValues> = Yup.object().shape({
  taxes: Yup.array().of(
    Yup.object().shape({
      stateCode : Yup.string().required(),
      taxValue  : Yup.number().required(),
    }),
  ),
});

export const bulkValidation = (name: string) => Yup.object().test(
  name,
  'Select at least 1 option',
  (val) => Object.values(val).some((el) => !!el),
);

export const bulkValidationSchema = Yup.object().shape({
  accounts : bulkValidation('accountsCheckboxes'),
  fees     : bulkValidation('feesCheckboxes'),
});
